import { render } from "./EventCategories.vue?vue&type=template&id=3bb22cdf&scoped=true"
import script from "./EventCategories.vue?vue&type=script&lang=js"
export * from "./EventCategories.vue?vue&type=script&lang=js"

import "./EventCategories.vue?vue&type=style&index=0&id=3bb22cdf&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bb22cdf"]])

export default __exports__